import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  isAiBuilder: false,
  // Capture ids the create-a-Wheel wizard must attach to the wheel it creates
  // (Capture inbox -> "Create Wheel", deck screen 06-create-new-confirm).
  // Empty for every other entry point, which all dispatch showCreateWheelPopup()
  // with no argument — so the wizard behaves exactly as before for them.
  seedCaptureIds: [],
  // Capture-only: after a successful Build, ask before navigating to /builder.
  // Gallery / Explore / header Create leave this false and keep the hard nav.
  promptAfterCreate: false,
};

const createWheelPopupSlice = createSlice({
  name: 'createWheelPopup',
  initialState,
  reducers: {
    showCreateWheelPopup(state, action) {
      state.isOpen = true;
      // Defensive: every legacy call site dispatches with no payload at all.
      const ids = action?.payload?.captureIds;
      state.seedCaptureIds = Array.isArray(ids) ? ids : [];
      state.promptAfterCreate = Boolean(action?.payload?.promptAfterCreate);
    },
    hideCreateWheelPopup(state) {
      state.isOpen = false;
      // Closing the wizard (Cancel, Escape, backdrop, or unmount) drops the
      // seed. A cancelled create must never leave a pending attach behind.
      state.seedCaptureIds = [];
      state.promptAfterCreate = false;
    },
    toggleCreateWheelPopup(state) {
      state.isOpen = !state.isOpen;
      if (!state.isOpen) {
        state.seedCaptureIds = [];
        state.promptAfterCreate = false;
      }
    },
  },
});

export const { showCreateWheelPopup, hideCreateWheelPopup, toggleCreateWheelPopup } =
  createWheelPopupSlice.actions;

export default createWheelPopupSlice.reducer;
